module.exports = __webpack_public_path__ + "media/images/new-45279532dfc0b3241602ab79d280007f.png";